"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingReleaseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const release_json_1 = __importDefault(require("@framework/abis/json/Vesting/release.json"));
const VestingReleaseButton = (props) => {
    const { balance, className, disabled, variant } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { execute: metaRelease } = (0, react_hooks_eth_1.useMetamask)(async (vesting) => {
        if (balance.token?.template?.contract?.contractType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: vesting.account,
                abi: release_json_1.default,
                functionName: "release",
                args: [balance.token?.template.contract.address],
            });
        }
        else if (balance.token?.template?.contract?.contractType === types_1.TokenType.NATIVE) {
            // https://ethereum.stackexchange.com/questions/132850/incorrect-gaslimit-estimation-for-transaction
            return writeContractAsync({
                address: vesting.account,
                abi: release_json_1.default,
                functionName: "release",
                args: [],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const handleClick = () => {
        return metaRelease(balance);
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleClick, icon: icons_material_1.Redeem, message: "form.tips.release", className: className, dataTestId: "VestingReleaseButton", disabled: disabled || balance.amount === "0", variant: variant }));
};
exports.VestingReleaseButton = VestingReleaseButton;
//# sourceMappingURL=index.js.map